module.exports = __webpack_public_path__ + "media/images/illustrations/wave-light-3-b23721dfd3cc74519d922fcff9112c34.svg";